import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { lighthouseCardMotion } from './motion';
import { lighthouseChromeTone } from './palette';

export const lighthouseTheme: FlowThemeDefinition = {
  id: 'lighthouse',
  label: 'Lighthouse',
  description: 'A coastal walk at sunset: every answer lights a lamp on the cliff path toward a lighthouse, until its beam sweeps the moonlit sea.',
  category: 'night',
  chromeTone: lighthouseChromeTone,
  swatch: 'linear-gradient(170deg, #1C2350 0%, #7A5F8E 38%, #F3A46E 55%, #323C6A 70%, #13224A 100%)',
  cardGlass: 'dense',
  cardMotion: lighthouseCardMotion,
  burstSize: 300,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createLighthouseScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
